module.exports = {
    expired_1: "لنک میعاد ختم ہوگیا",
    limit_time: "محدود وقت کی پیشکش ",
    participate: "اپنا خصوصی انعام حاصل کرنے کے لیے ابھی جائزہ ایونٹ میں حصہ لیں!",
    exclusive: "خصوصی",
    reward: "انعام",
    token: "ٹوکن",
    vip: "دن VIP",
    after_completing: "جائزہ اور اسکرین شاٹ کی تصدیق مکمل کرنے کے بعد، آپ کو موصول ہوگا",
    step_1: "<strong style='color: #000000'>نیچے دیے گئے بٹن پر کلک کریں</strong> ایپ اسٹور پر جانے کے لیے اور <strong style='color: #000000'>5 ستاروں کا جائزہ دیں۔</strong>",
    step_2: "جائزہ مکمل کرنے کے بعد، براہ کرم اپنے جائزے کے مواد کی <strong style='color: #000000'>اسکرین شاٹ لیں</strong>۔",
    step_3: "اپنا انعام وصول کرنے کے لیے <strong style='color: #000000'>اسکرین شاٹ اپ لوڈ کریں</strong> نیچے اور اپنا ایپ آئی ڈی جمع کروائیں۔",
    click_to: "1. پر جانے کے لیے کلک کریں ",
    upload: "2. جائزہ اسکرین شاٹ اپ لوڈ کریں",
    app_store: "ایپ اسٹور",
    google_play: "گوگل پلے",
    go_to: "پر جائیں ",
    example: "اسکرین شاٹ مثال",
    upload_screenshot: "اسکرین شاٹ اپ لوڈ کریں",
    claim: "انعام حاصل کریں",
    verification_inprogress: "اپ لوڈ کرنے کا شکریہ۔ آپ کی اسکرین شاٹ جلد از جلد جائزہ لیا جا رہا ہے۔ براہ کرم صبر کریں۔",
    verification_success: "مبارک ہو! <br/><br/> آپ نے کامیابی سے اپنا انعام حاصل کر لیا ہے۔ انعام آپ کے کھاتے میں <strong>24 گھنٹوں کے اندر</strong> جمع کر دیا جائے گا۔ براہ کرم انتظار کریں۔ <br/><br/> اگر آپ کے کوئی سوالات ہیں، تو براہ کرم کسٹمر سپورٹ سے رابطہ کریں۔",
    verification_failed: "جائزہ کی اسکرین شاٹ کو درج ذیل شرائط پر پورا اترنا چاہیے: <br/><br/> <div style='margin-left: 6px'> 1.درجہ بندی 5 ستاروں کی ہونی چاہیے اور مواد مثبت ہونا چاہیے۔ <br/><br/> 2.جائزہ <strong>ایپل ایپ اسٹور یا گوگل پلے اسٹور</strong> پر دیا جانا چاہیے۔ <br/><br/> 3.اسکرین شاٹ میں جائزے کا مواد مکمل طور پر دکھائی دینا چاہیے، بشمول <strong>اوتار، صارف نام اور جائزہ متن</strong>۔ <strong></div>",
    reupload: "دوبارہ اپ لوڈ کریں",
}